"use strict";
/** The HLM System panel UI */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemPanelInit = SystemPanelInit;
const jquery_1 = __importDefault(require("jquery"));
function SystemPanelInit() {
    // initialize dialog
    var $dialog = (0, jquery_1.default)("#system_panel");
    $dialog.dialog({
        title: "System Panel",
        autoOpen: false,
        modal: false,
        width: 500,
        height: 400,
        resizable: false
    });
    // listen for selection events from model to open/close dialog
    window.addEventListener('UnityObjectSelected', function (e) {
        var transform_name = e.detail.name;
        if (transform_name.trim() === "System Panel") {
            $dialog.dialog("open");
        }
        if (transform_name.trim() === "HLM Machine OFF Button") {
            $dialog.dialog("close");
        }
    });
    // if #system_panel .btn does not have onclick, set to disabled
    const buttons = document.querySelectorAll('#system_panel .btn');
    buttons.forEach(function (btn) {
        if (!btn.getAttribute('onclick')) {
            btn.classList.add('disabled');
        }
    });
}
